import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges
} from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { Observable, of } from "rxjs";
import { Resposta } from "../models/resposta";
import { RespostaListaDinamicaService } from "../services/resposta-lista-dinamica.service";
import { RespostaListaDinamica } from "../models/resposta.lista-dinamica.model";
import { Questionario } from "../models/questionario";
import { QuestionarioDinamicoService } from "../services/questionario-dinamico.service";
import { MatSnackBar } from "@angular/material";

@Component({
  selector: "resposta-list-dinamico",
  template: `<div *ngIf="isLoading" [ngClass]="{'block-content':isLoading}">
  <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
</div>

<!-- Lista Resposta -->
<div class="card" *ngIf="!isLoading">
  <div class="header">
    <h2>Lista de Respostas</h2>
  </div>
  <div class="body">
    <table class="table table-bordered table-striped table-hover">
      <thead *ngIf="lista != null && lista.linhas != null && lista.linhas.length > 0">
        <tr>
          <th *ngFor="let col of lista.colunas">{{col}}</th>
          <th class="text-center">Ação</th>
        </tr>
      </thead>
      <tbody *ngIf="lista != null && lista.linhas != null && lista.linhas.length > 0">
        <tr *ngFor="let linhas of lista.linhas">
          <td *ngFor="let valor of linhas">
            {{valor}}
          </td>
          <td class="text-center">
            <button title="Editar" type="submit" class="btn btn-primary" (click)="editar(linhas[0])"
              *ngIf="mostrarEditar">
              <i class="material-icons">create</i>
            </button>

            <button title="Selecionar" *ngIf="botaoSelecionar" type="submit" class="btn btn-primary"
              (click)="respostaEmitido(linhas[0])">
              <i class="material-icons">input</i>
            </button>

            <button title="Excluir" type="submit" class="btn btn-danger" (click)="itemSelecionado = linhas[0]"
              data-toggle="modal" data-target="#modalExcluir" *ngIf="mostrarExcluir">
              <i class="material-icons">delete</i>
            </button>

          </td>
        </tr>
      </tbody>
      <tbody *ngIf="lista == null || (lista!= null && lista.linhas != null && lista.linhas.length == 0)">
        <tr>
          <td colspan="2" style="text-align: center">
            <p>Nenhum registro encontrado</p>
          </td>
        </tr>
      </tbody>
    </table>
    <button mat-raised-button color="primary" (click)="novo()" *ngIf="mostrarNovo">
      <mat-icon>add</mat-icon> Novo
    </button>
  </div>
</div>

<div class="card" *ngIf="controlaModal">
  <questionario-dinamico [idQuestionario]="questionario.id" [questionarioPreCarregado]="questionarioPreCarregado"
    [novoEmmiter]="novoEmmiter" (respostaEmitida)="respostaEmitido($event)" [resposta]="resposta"
    [botaoSalvar]="mostrarSalvar" [botaoResetar]="mostrarResetar" [botaoSelecionarPergunta]="botaoSelecionarPergunta"
    (perguntaEmitida)="emitirPergunta($event)"></questionario-dinamico>
</div>

<!-- #END# Lista Resposta -->

<!-- Modal Confirma Exclusao Resposta -->
<div id="modalExcluir" class="modal fade" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal">&times;</button>
        <h4 class="modal-title">Confirme a exclusão</h4>
      </div>
      <div class="modal-body">
        <p>Tem certeza que deseja excluir o registro?</p>
      </div>
      <div class="modal-footer">
        <button mat-raised-button color="primary" data-dismiss="modal" (click)="deletar()">
          <mat-icon>check</mat-icon>Confirmar
        </button>
        <button mat-raised-button color="primary" data-dismiss="modal">
          <mat-icon>close</mat-icon> Cancelar
        </button>
      </div>
    </div>
  </div>
</div>`
})
export class RespostaListaDinamicaComponent {
  public itemSelecionado: number;
  public lista: RespostaListaDinamica;
  public questionario: Questionario;
  public mostrarQuestionarioNoForm: boolean = false;
  public resposta: Resposta;
  public novoEmmiter: boolean;
  public controlaModal: boolean;

  // Controla o loading da página
  public isLoading: boolean;

  @Input() filtro: Resposta;
  // determina se o codigo do idQuestionario foi setado
  @Input() idQuestionario: number;
  // nomeUnico vem da pagina que usara o componente
  @Input() nomeQuestionario: string;
  // esse Input, permite que o usuário já carregue um questionário pre-carregado para o componente.
  // isso melhora a performance, pois esse componente nao precisa ficar carregando o questionario toda hora.
  @Input() questionarioPreCarregado: Questionario;
  // determina se o codigo do idQuestionario foi setado
  @Input() naoCarregarResultadosIniciar: boolean;
  // determina se aparece um botao de selecionar, que emite o valor selecionado pra manipulacao
  @Input() botaoSelecionar: boolean = false;
  // lista de respostas que jah vem
  @Input() listaRespostas: RespostaListaDinamica;
  // essa condicao eh pra casos onde a resposta eh em Modal e eu quero que carregue resultados somente da lista de respostas
  @Input() listaRespostasObrigatorio: boolean;
  // controle dos botões
  @Input() mostrarExcluir: boolean = true;
  @Input() mostrarEditar: boolean = true;
  @Input() mostrarSalvar: boolean = true;
  @Input() mostrarResetar: boolean = true;
  @Input() mostrarNovo: boolean = true;
  // controla a emissão da Row. O padrão é não emitir. Caso queira que emita, então chamar o componente com essa [emitirRow = true]
  @Input() emitirRow: boolean = false;
  // controla o botao de selecionar pergunta (usado em casos da pergunta na mesma tela)
  @Input() botaoSelecionarPergunta: boolean = false;
  // emite a resposa selecionada
  @Output() respostaEmitida: EventEmitter<number> = new EventEmitter<number>();
  // Emite uma exclusao
  @Output() exclusaoEmitida: EventEmitter<number> = new EventEmitter<number>();
  // Emite a row selecionada no editar
  @Output()
  rowSelecionadaEmitida: EventEmitter<number> = new EventEmitter<number>();
  // Emite a pergunta selecionada
  @Output()
  perguntaSelecionadaEmitida: EventEmitter<number> = new EventEmitter<number>();

  // construtor
  constructor(
    public respostaListaDinamicaService: RespostaListaDinamicaService,
    public router: Router,
    public questionarioService: QuestionarioDinamicoService,
    public route: ActivatedRoute,
    public mensagem: MatSnackBar
  ) {}

  // ngOnInit é executado ao entrar na tela
  ngOnInit() {
    this.carregaQuestionario();
  }

  public carregaQuestionario() {
    let questionarioRecuperado: Observable<Questionario> = new Observable<
      Questionario
    >();
    if (this.questionarioPreCarregado) {
      questionarioRecuperado = of(this.questionarioPreCarregado);
    } else if (this.idQuestionario) {
      questionarioRecuperado = this.questionarioService.recuperaQuestionarioCompleto(
        this.idQuestionario,
        ""
      );
    } else if (this.nomeQuestionario) {
      questionarioRecuperado = this.questionarioService.recuperaQuestionarioCompleto(
        0,
        this.nomeQuestionario
      );
    }

    this.isLoading = true;
    questionarioRecuperado.subscribe(
      (resultQuestionario: Questionario) => {
        this.questionario = resultQuestionario;
        if (!this.naoCarregarResultadosIniciar) {
          this.filtro = new Resposta();
          this.filtro.questionario = this.questionario.id;
          this.carregarLista();
        }
      },
      error => this.erro(error)
    );
  }

  // Se a resposta eh em modal, entao nao tem filtro, e sim lista de respostas
  carregarLista() {
    if (this.listaRespostasObrigatorio) {
      if (this.listaRespostas) {
        this.lista = this.listaRespostas;
      }
      this.isLoading = false;
    } else if (this.filtro && this.filtro.questionario) {
      this.isLoading = true;
      this.respostaListaDinamicaService.filtrar(this.filtro).subscribe(
        result => {
          this.lista = result;
          this.isLoading = false;
        },
        error => this.erro(error)
      );
    }
  }

  novo() {
    if (
      this.questionario.mostrarRespostaModal &&
      this.questionario.mostrarRespostaModal == true
    ) {
      this.controlaModal = true;
      this.mostrarQuestionarioNoForm = false;
      this.resposta = new Resposta();
      this.mostrarQuestionarioNoForm = true;
      // Tava tendo um problema da tela carregar duas vezes no primeiro clique do botao novo. Entao a solucao foi essa:
      // a primeira vez q o emmiter eh chamado, ele vem null (por conta da declaracao da variavel lah em cima), entoa eu seto ela como false
      // ai o questionario-dinamico vai ignorar essa primeira chamada. Nas proximas vezes, eu setto o novoEmmiter pra true, ai sim, soh vai limpar uma vez a tela.
      if (this.novoEmmiter == undefined) {
        this.novoEmmiter = false;
      } else {
        this.novoEmmiter = true;
      }
    } else {
      if (this.questionario.id) {
        this.router.navigate([
          "/resposta",
          "new",
          { idQuestionario: this.questionario.id }
        ]);
      } else {
        this.mensagem.open("Selecione um questionário!!", "X", {
          duration: 5000
        });
      }
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    for (let propName in changes) {
      let chng = changes[propName];

      if (propName == "filtro") {
        this.filtro = chng.currentValue;
        if (this.filtro) {
          this.carregarLista();
        }
      }
      if (propName == "listaRespostas") {
        this.listaRespostas = chng.currentValue;
      }
    }
  }

  editar(codigo: number) {
    if (
      this.questionario.mostrarRespostaModal &&
      this.questionario.mostrarRespostaModal == true
    ) {
      this.resposta = new Resposta();
      this.isLoading = true;
      this.controlaModal = false; // faco isso pra forcar o update do componente
      this.respostaListaDinamicaService
        .getRespostaCompletaPorPergunta(codigo)
        .subscribe(
          (result: Resposta) => {
            this.controlaModal = true;
            this.resposta = result;
            this.novoEmmiter = false;
            this.isLoading = false;
            if (this.emitirRow) {
              this.rowSelecionadaEmitida.emit(result.id);
            }
          },
          error => this.erro(error)
        );
    } else {
      this.router.navigate(["/resposta", codigo]);
    }
  }

  // Recebe o valor filtrado do componente filtro dinamico
  filtrarOutCome(event: any) {}

  respostaEmitido(codigo: number) {
    this.respostaEmitida.emit(codigo);

    //Se a resposta for em modal eu mando esconder o modal depois de emetir, pra voltar lah pra lista
    if (this.questionario.mostrarRespostaModal) {
      this.controlaModal = false;
    }
  }

  deletar() {
    this.isLoading = true;
    this.respostaListaDinamicaService.deletar(this.itemSelecionado).subscribe(
      result => {
        this.mensagem.open("Registro excluído com sucesso!", "X", {
          duration: 5000
        });
        this.exclusaoEmitida.emit(this.itemSelecionado);
        this.carregarLista();
        this.isLoading = false;
      },
      error => this.erro(error)
    );
  }

  public emitirPergunta($event: number) {
    this.perguntaSelecionadaEmitida.emit($event);
  }

  // mostra erros na tela
  erro(erro: string) {
    this.mensagem.open("Erro: " + erro, "X", { duration: 5000 });
    this.isLoading = false;
  }

  // finaliza o subscribe
  finaliza() {
    this.isLoading = false;
  }
}
